<template>
  <div class="com-box" :class="{'com-box-margin': creationMode}">
    <div class="com-title">
      <span class="title-label">上传图片</span>
      <span class="title-tip" v-if="!tmpType ||tmpType == 0 || tmpType == 3">(建议高度≤560,最多支持5张轮播)</span>
      <span class="title-tip" v-else>(推荐尺寸620x424,最多支持5张轮播)</span>
    </div>
    <div class="com-content" :class="{'com-content-margin': creationMode}">
      <template v-for="(item,index) in imgList" >
        <div class="img-box" :key="index">
          <div class="img">
            <van-image 
              fit="cover"
              class="img"
              :src="item.moduleDetailValue"
              @click="imgPreview([item.moduleDetailValue])"
            />
            <div class="del-img-btn" @click="deleteImg(item)">
              <van-icon class="del-icon" name="cross" size="12" />
            </div>
            <div class="cove" v-if="item.status == 'uploading'">
              <van-loading  color="#fff" text-color="#fff" :text-size="12" :size="28" vertical >上传中...</van-loading>
            </div>
          </div>
          <div class="input">
            <van-field v-model="item.remark" maxlength="9" type="digit" placeholder="请输入活动id" @input="changeInput"/>
          </div>
        </div>
      </template>
      <van-uploader 
        v-if="imgList.length < 5"
        class="uploader"
        :max-count="5" 
        preview-size="97" 
        :before-read="beforeImgUpload" 
        :after-read="uploadImg"
      />
    </div>
  </div>
</template>

<script>
import { ImagePreview } from 'vant';
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: Array,
    tmpType: Number
  },
  watch: {
    value: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.initForm(newVal);
        }
      },
      deep: true,
      immediate: true
    },
  },
  computed: {
    // 组件创建方式
    creationMode() {
      return this.$route.query.creationMode != 'new' ? true : false
    }
  },
  data() {
    return {
      imgList: [],
    }
  },
  methods: {
    initForm(val) {
      if (val) {
        this.imgList = val.map(item => ({
          ...item,
          url: item.moduleDetailValue
        }));
      }
    },
    onFormChange() {
      const imgList = this.imgList.map((item, index) => ({
        ...item,
        sortNo: index,
      }));
      this.$emit('change', imgList);
    },
    changeInput() {
      this.$emit('change', this.imgList);
    },
    beforeImgUpload(file) {
      const acceptTypes = ['image/png', 'image/jpeg', 'image/gif'];
      if (!acceptTypes.includes(file.type)) {
        this.$toast('请上传png、jpg或gif格式图片');
        return false;
      }

      return true;
    },
    uploadImg(file) {
      const currentFile = {
        url: '',
        status: 'uploading',
        message: '上传中...',
        detailDataType: 1,
        moduleDetailValue: '',
        remark: ''
      };
      this.imgList.push(currentFile);
      this.$api.common.uploadImg(file.file)
        .then(({data}) => {
          if (data && data[0]) {
            const fileUrl = data[0].fileUrl;
            file.moduleDetailValue = fileUrl;
            currentFile.url = fileUrl;
            currentFile.moduleDetailValue = fileUrl;
            currentFile.status = 'done';
            this.onFormChange();
          }
        })
        .catch(err => {
          const currentIndex = this.imgList.indexOf(currentFile);
          if (currentIndex > -1) {
            this.imgList.splice(currentIndex, 1);
          }
        });
    },
    isClone() {
      return this.$route.query.from == 'clone';
    },
    deleteImg(file) {
      let isClone = this.isClone()
      const param = {
        activityId: !isClone ? this.$route.query.activityId || '' : '',
        primaryKey: !isClone ? file.moduleDetailId || '' : '',
        imageUrl: file.moduleDetailValue,
        sourceType: 1
      };
      this.$api.common.deleteImg(param)
        .then(() => {
          const index = this.imgList.findIndex(item => item.moduleDetailValue === file.moduleDetailValue);
          if (index > -1) {
            this.imgList.splice(index, 1);
          }
          this.onFormChange();
        });
    },
    imgPreview(img) {
      ImagePreview(img)
    }
  }
}
</script>

<style lang="stylus" scoped>
.com-box
  .com-title
    padding 15px 15px 0 15px;
    .title-label
      font-size 14px
      font-weight bold
      color #303133
    .title-tip
      margin-left 10px
      font-size 12px
      color #999
  .com-content
    padding 15px 15px 5px
    background-color: #fff
    border-radius: 8px
    .img-box {
      .img {
        position: relative;
        width: 97px;
        height: 97px;
        margin-bottom: 4px;
        .del-img-btn {
          position: absolute;
          right: 0;
          top: 0;
          width: 20px;
          height: 20px;
          background-color: rgba(0, 0, 0, 0.7);
          border-radius: 0 0 0 18px;
          .del-icon {
            right: -5px;
            color: #fff;
            z-index: 99;
          }
        }
        .cove {
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          background: rgba(0,0,0, 0.6);
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
      .input {
        >>> .van-cell {
          padding: 2px 16px;
        }
        border: 1px solid #ebedf0;
        border-radius: 4px;
        margin-bottom: 10px;
      }
    }
  .uploader
    >>> .van-uploader__preview
      border-radius: 8px 
      overflow hidden
      .van-uploader__preview-delete
        width 20px
        height 20px
        border-bottom-left-radius 18px
        .van-uploader__preview-delete-icon
          font-size 20px
.com-box-margin {
  margin 15px 0
  .com-content-margin {
    margin 10px 15px
  }
}
</style>